import { supabase } from '../lib/supabase'

/** I formati offerti nel passo di firma. La ricevuta e' a parte: esiste solo
 * dopo l'invio ed e' scaricabile dal passo `inviata`. */
export const FORMATI_SCARICABILI = ['xml', 'c01', 'pdf'] as const
export type FormatoScaricabile = (typeof FORMATI_SCARICABILI)[number] | 'ricevuta'

/** Naviga all'URL firmato invece di aprire un popup: `window.open` dopo
 * un'attesa asincrona non e' piu' legato al click e i browser lo bloccano.
 * L'URL risponde con Content-Disposition: attachment, quindi la pagina resta. */
export function avviaDownload(url: string): void {
  window.location.assign(url)
}

/** L'URL e' firmato e a scadenza breve: lo emette il server (Edge Function
 * scarica-dichiarazione, RLS-scoped sul JWT del chiamante), mai il client —
 * generare una firma R2 richiede le credenziali del bucket. */
export async function scarica(dichiarazioneId: number, formato: FormatoScaricabile): Promise<string> {
  if (formato !== 'ricevuta' && !(FORMATI_SCARICABILI as readonly string[]).includes(formato)) throw new Error(`Formato non supportato: ${formato}`)
  const { data, error } = await supabase.functions.invoke('scarica-dichiarazione', {
    body: { dichiarazioneId, formato },
  })
  if (error) throw new Error(error.message)
  return (data as { url: string }).url
}

/** I file di un invio preciso: dopo una rettifica quelli sulla dichiarazione
 * sono dell'ultimo giro, quelli degli invii precedenti restano sulla loro riga
 * di `invio`. */
export type FormatoInvio = 'ricevuta' | 'xml_firmato' | 'esito'

export async function scaricaDaInvio(invioId: number, formato: FormatoInvio): Promise<string> {
  const { data, error } = await supabase.functions.invoke('scarica-dichiarazione', {
    body: { invioId, formato },
  })
  if (error) throw new Error(error.message)
  return (data as { url: string }).url
}
